
import store from "../store";
export default {    
    getAuthorization(){
        var APPID='wxd8669654e2c13e60'
        var code=this.getUrlParam('code')
        var local=window.location.href
        // this.getOpenId()
        if(code==null||code==""){
            if (/(micromessenger)/i.test(navigator.userAgent)) {
                window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri='+encodeURIComponent(local)+'&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect&connect_redirect=1'
                console.log('无code测试，测试！！！')      
            } else {
                localStorage.setItem('browser', true)
                //    alert('其他浏览器')
              }
        }else{
            console.log("有code测试，测试！！！")
            this.getOpenId(code)
        }
    },
    getUrlParam(name){
        var reg=new RegExp('(^|&)'+name+'=([^&]*)(&|$)')
        var r=window.location.search.substr(1).match(reg)
        if(r!=null) return unescape(r[2])
            return null
    },
    getOpenId(code){
        var params={
            code:code,
            source:1
        }
        axios.get('/api/app-login',{params:params})
        .then((res) => {
            console.log(res.data.data.access_token)
            var meminfo=res.data.data.user
            // alert('接口请求成功'+meminfo.username)
            localStorage.setItem('userinfo', JSON.stringify(res.data.data.user))
            localStorage.setItem('token', res.data.data.access_token)
            localStorage.setItem('onload', 1)
            store.dispatch('param/setToken', res.data.data.access_token)
            // if(meminfo.mobile){

            // }else{
            //     this.$router.push({name:'BoundMobile',params:{source:1}});
            // }
        })
    }

}